import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import PopoverButton from '../../PopoverButton';
import Checkbox from '../../Checkbox';

const Filters = ({ filters, onFilterChange, iconOnly = false }) => {
  const { t } = useTranslation('dealers');
  const [selectedFilters, setSelectedFilters] = useState(filters.filter(item => item.active).map(filter => filter.value));
  const filterInfo = t('Filter info');
  const showFilterInfo = !!filterInfo;

  const toggleFilter = (id) => {
    const f = [...selectedFilters];

    if (f.includes(id)) {
      f.splice(f.indexOf(id), 1);
    } else {
      f.push(id);
    }

    setSelectedFilters(f);
  };

  const filterRef = useRef(null);

  const uiFilters = filters.filter(filter => filter.showUI);
  const filterOptionElements = uiFilters.map((filter) => {
    return (
      <Checkbox key={filter.value} label={filter.name} checked={selectedFilters.includes(filter.value)} onChange={() => toggleFilter(filter.value)}/>
    );
  });

  const filterCount = uiFilters.filter(filter => filter.active).length;
  return (
    <div className={'filters'} ref={filterRef} data-active-filters={filterCount || null}>
      {showFilterInfo && (
        <PopoverButton
          iconBefore="icon-info"
          iconOnly
          closable
          label={t('Filter info button')}
        >
          {(props) => (
            <span dangerouslySetInnerHTML={{ __html: filterInfo }}></span>
          )}
        </PopoverButton>
      )}

      <PopoverButton
        className="filter-popover"
        dropdownClassName={'filter-dropdown'}
        iconAfter={iconOnly ? 'filter' : 'Chevron-Black'}
        iconOnly={iconOnly}
        iconV2={iconOnly}
        label={iconOnly ? null : (
          <>
            {t('Filter results')}
            {filterCount > 0 && <strong>{`(${filterCount})`}</strong>}
          </>
        )}
      >
        {({ close }) => (
          <>
            {filterOptionElements}
            <button className="button button--primary filter-submit" type="button" onClick={() => { onFilterChange(selectedFilters); close(); }}>
              {t('Filter results cta')}
            </button>
          </>
        )}
      </PopoverButton>
    </div>
  );
};

Filters.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    name: PropTypes.string,
    active: PropTypes.bool,
  })),
  onFilterChange: PropTypes.func,
  iconOnly: PropTypes.bool,
};

export default Filters;
